module.exports = __webpack_public_path__ + "static/media/ComputerTalk_Step2_Image5.527883a5.jpg";